export default function Problem() {
  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">私たちが実現する、スピードとコスト</h2>
          <p className="text-gray-500 text-sm md:text-base">従来のPoC(概念実証)の前提を覆します</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Negative */}
          <div className="bg-white border border-red-100 rounded-2xl p-8">
            <h3 className="text-lg font-bold text-red-500 mb-5 flex items-center gap-2">
              <span className="w-7 h-7 flex items-center justify-center bg-red-100 rounded-full">
                <i className="ri-close-line text-red-500 text-base"></i>
              </span>
              従来の開発では...
            </h3>
            <ul className="space-y-3">
              {[
                "PoCだけで2〜3ヶ月、300〜500万円が消える",
                "動く成果物が出るまで何も見えない",
                "仕様変更のたびに追加費用が発生",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-700 text-sm">
                  <span className="mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-close-circle-line text-red-400 text-base"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          {/* Positive */}
          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-8">
            <h3 className="text-lg font-bold text-blue-600 mb-5 flex items-center gap-2">
              <span className="w-7 h-7 flex items-center justify-center bg-blue-100 rounded-full">
                <i className="ri-check-line text-blue-600 text-base"></i>
              </span>
              AI活用開発なら
            </h3>
            <ul className="space-y-3">
              {[
                "1〜2週間で動くプロトタイプを提示",
                "毎日のレビューで進捗が見える",
                "期間中の方向修正は追加費用なし",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-700 text-sm">
                  <span className="mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-double-line text-blue-500 text-base"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Solution */}
        <div className="mt-12 bg-white border border-gray-200 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
            <div>
              <h3 className="text-xl font-extrabold text-gray-900 mb-4 leading-snug">
                一連のプロセスをAIに最適化し、<br />
                エンジニアが品質責任を負う。
              </h3>
              <ul className="space-y-5">
                {[
                  {
                    icon: "ri-flashlight-line",
                    title: "通常の3〜5倍の開発スピード",
                    desc: "AIを活用した開発体制で、1〜2週間で動くプロトタイプをお届けします",
                  },
                  {
                    icon: "ri-user-star-line",
                    title: "エンジニアが品質を保証",
                    desc: "設計・レビュー・品質管理は経験豊富なエンジニアが責任を持って担当します",
                  },
                  {
                    icon: "ri-refresh-line",
                    title: "期間中の方向修正は無料",
                    desc: "毎日のレビューでフィードバックを反映。仕様変更にも柔軟に対応します",
                  },
                ].map((f) => (
                  <li key={f.title} className="flex items-start gap-4">
                    <span className="w-9 h-9 flex items-center justify-center bg-blue-100 rounded-xl flex-shrink-0">
                      <i className={`${f.icon} text-blue-600 text-lg`}></i>
                    </span>
                    <div>
                      <div className="font-bold text-gray-900 text-sm mb-1">{f.title}</div>
                      <div className="text-gray-500 text-xs leading-relaxed">{f.desc}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-gray-50 rounded-2xl p-6">
              <h4 className="text-sm font-bold text-gray-700 mb-5"><a href="#comparison" className="text-gray-700 hover:text-gray-700 cursor-pointer">開発期間の比較</a></h4>
              <div className="space-y-4">
                <div>
                  <div className="text-xs text-gray-500 mb-1">従来のPoC</div>
                  <div className="bg-red-100 text-red-600 font-bold text-sm rounded-lg px-4 py-3 w-full">
                    2〜3ヶ月
                  </div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">AI活用開発</div>
                  <div className="bg-blue-600 text-white font-bold text-sm rounded-lg px-4 py-3 w-2/5">
                    1〜2週間
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-5 leading-relaxed">
                同じ成果物を、通常の <strong className="text-gray-700">6分の1 〜 12分の1の期間</strong> で実現します。
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <a
            href="#contact"
            className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg md:text-xl py-5 md:py-6 rounded-xl transition-all shadow-xl shadow-blue-600/30 hover:shadow-blue-500/50 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            まずは無料で、モックの作成から &rarr;
          </a>
        </div>
      </div>
    </section>
  );
}
